/* ============
 * AssetComponent
 * ============
 */

export default {
  namespaced: true,
};
